<template>
  <div>
    <v-toolbar flat class="rounded-b-0" style="background: transparent;">
      <v-spacer />

      <template v-if="$vuetify.breakpoint.smAndUp">
        <v-row justify="end" no-gutters>
          <v-col cols="3" class="py-0 my-0" align-self="center">
            <v-hover
              v-slot="{ hover }"
            >
              <v-select
                class="py-0 px-1"
                v-model="chartTimeScale"
                item-value="timeScale"
                :items="chartTimeScaleOptions"
                :label="hover ? $t('scale') : null"
                return-object
                hide-details
              >
                <template #selection="{ item }">
                  <div>
                    {{ $tc(item.name.unit, item.name.num) }}
                  </div>
                </template>
                <template #item="{ item }">
                  <div>
                    {{ $tc(item.name.unit, item.name.num) }}
                  </div>
                </template>
              </v-select>
            </v-hover>
          </v-col>
          <v-col cols="auto">
            <v-menu offset-y>
              <template #activator="{ on: menu }">
                <v-tooltip top>
                  <template #activator="{ on: tooltip }">
                    <v-btn v-on="{ ...tooltip, ...menu }" icon>
                      <v-icon>
                        timer
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('refresh_rate') }}</span>
                </v-tooltip>
              </template>
              <v-card>
                <v-list>
                  <v-list-item
                    v-for="(option, index) in chartRefreshIntervalOptions"
                    :key="index"
                    :class="{ 'bg-selected-item': option.value === refreshInterval }"
                    @click="refreshIntervalSelected(option)"
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{ option.name }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </v-col>
        </v-row>
      </template>

      <v-tooltip :disabled="$vuetify.breakpoint.xsOnly" bottom>
        <template #activator="{ on }">
          <v-btn icon v-on="on" @click="reloadMon">
            <v-icon outline>
              autorenew
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $tc('reload') }}</span>
      </v-tooltip>

      <template v-if="isStarted">
        <v-tooltip :disabled="$vuetify.breakpoint.xsOnly" bottom>
          <template #activator="{ on }">
            <v-btn icon v-on="on" @click="stopMon">
              <v-icon outline>
                pause
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $tc('stop') }}</span>
        </v-tooltip>
      </template>

      <template v-else>
        <v-tooltip :disabled="$vuetify.breakpoint.xsOnly" bottom>
          <template #activator="{ on }">
            <v-btn icon v-on="on" @click="startMon">
              <v-icon outline>
                play_arrow
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $tc('start') }}</span>
        </v-tooltip>
      </template>
    </v-toolbar>

    <v-card outlined class="rounded-lg pa-6">
      <cpu-chart id="cpu_memory_monitor" :height="300" :chart-data="chartData" :options="chartOptions" />
    </v-card>

    <!-- <v-row class="pa-6">
      <v-col v-for="(item, key) in statusBlocks" cols="12" md="6" :key="`statusblock-${key}`">
        <v-row>
          <v-col cols="12">
            <h3 class="title text_secondary--text text-center mb-1">
              {{ $t(item.title) }}
            </h3>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-progress-circular
            class="hide-in-percy"
            :rotate="360"
            :size="130"
            :width="10"
            :value="item.value"
            color="timid"
          >
            <span class="f-30px hide-in-percy">
              {{ item.value }}%
            </span>
          </v-progress-circular>
        </v-row>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
import CpuChart from './CpuChart'
export default {
  components: {
    CpuChart
  },
  created () {
    this.$store.dispatch('cpuMon/getInfo')
    this.$store.dispatch('hsm/getLogSize')
  },
  data () {
    return {
      popup: null
    }
  },
  computed: {
    chartData () {
      return {
        labels: [],
        datasets: [{
          label: this.$t('processing'),
          borderColor: this.$vuetify.theme.themes[this.darkMode ? 'dark' : 'light'].cpuChartLine,
          cubicInterpolationMode: 'monotone',
          data: []
        }, {
          label: this.$t('memory'),
          borderColor: this.$vuetify.theme.themes[this.darkMode ? 'dark' : 'light'].ramChartLine,
          cubicInterpolationMode: 'monotone',
          data: []
        }]
      }
    },
    chartOptions () {
      return {
        legend: {
          position: 'top',
          align: 'start'
        },
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            gridLines: {
              display: false
            },
            type: 'realtime',
            realtime: {
              duration: 20000,
              refresh: 1000,
              delay: 1000,
              pause: true,
              // 32 hours, allowing 50% time 'rollback'
              // for the biggest time scale, 24 hours
              ttl: 32 * 60 * 60 * 1000
              // onRefresh: function (chart) { console.log('onRefresh') }
            },
            time: {
              minUnit: 'second'
            }
          }],
          yAxes: [{
            type: 'linear',
            display: true,
            ticks: {
              min: 0,
              max: 100,
              stepSize: 20,
              callback: function (value, index, values) {
                return value + '%'
              }
            }
          }]
        },
        tooltips: {
          mode: 'nearest',
          intersect: false
        },
        hover: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            pan: {
              enabled: true,
              mode: 'x'
            },
            zoom: {
              enabled: false
              // mode: 'x',
              // drag: true,
              // speed: 0.9,
              // rangeMin: {
              //   x: null
              // },
              // rangeMax: {
              //   x: Date.now() + this.chartTimeScale.timeScale
              // },
              // onZoom: function ({ chart }) { console.log(`I'm zooming!!!`) }
            }
          }
        }
      }
    },
    chartRefreshIntervalOptions () {
      const allOptions = this.$store.getters['cpuMon/getRefreshIntervalOptions']
      let res
      switch (this.chartTimeScale.id) {
        case '1m' : res = allOptions.slice(0, 2); break
        case '5m' : res = allOptions.slice(0, 3); break
        case '1h' : res = allOptions.slice(0, 3); break
        case '3h' : res = allOptions.slice(); break
        case '6h' : res = allOptions.slice(); break
        case '24h': res = allOptions.slice(); break
        default: res = allOptions.slice()
      }
      return res
    },
    chartTimeScaleOptions () {
      return this.$store.getters['cpuMon/getTimeScaleOptions']
    },
    refreshInterval: {
      get () {
        return this.$store.state.cpuMon.refreshInterval
      },
      set (val) {
        this.$store.commit('cpuMon/SET_FRESH_INTERVAL', val)
      }
    },
    chartTimeScale: {
      get () {
        return this.$store.state.cpuMon.timeScale
      },
      set (val) {
        return this.$store.commit('cpuMon/SET_TIME_SCALE', val)
      }
    },
    darkMode () {
      return this.$store.state.ui.darkModeEnabled
    },
    firmwareVersion () {
      return this.$store.state.cpuMon.data.firmwareVersion
    },
    syncPoint () {
      return this.$store.state.cpuMon.data.syncPoint
    },
    date () {
      return this.$store.state.cpuMon.data.date
    },
    cpu () {
      return this.$store.state.cpuMon.data.cpu
    },
    ram () {
      return this.$store.state.cpuMon.data.ram
    },
    statusBlocks () {
      const cpu = this.cpu
      const ram = this.ram

      return [
        {
          title: 'processing',
          value: cpu
        },
        {
          title: 'memory',
          value: ram
        }
      ]
    },
    isStarted () {
      return this.$store.getters['cpuMon/isStarted']
    },
    isPopup () {
      return this.$route.name === 'monitor-cpu-popup'
    }
  },
  methods: {
    percentLogSize (bytes) {
      const totalMemory = 4 * 1024 * 1024 * 1024 // 4GB in bytes
      return (bytes / totalMemory) * 100
    },
    startMon () {
      this.$store.dispatch('cpuMon/start')
    },
    stopMon () {
      this.$store.dispatch('cpuMon/stop')
    },
    reloadMon () {
      this.$store.commit('cpuMon/SET_DATA')
      this.$store.commit('cpuMon/CLEAR_DATASETS')
      this.$store.dispatch('cpuMon/getInfo')
    },
    refreshIntervalSelected (refreshIntervalOption) {
      this.refreshInterval = refreshIntervalOption.value
    },
    openPopup () {
      this.stopMon()
      const name = 'monitor-cpu-popup'
      const route = this.$router.resolve({ name })

      this.$store
        .dispatch('ui/setPopup', {
          exists: this.popup,
          url: route.href
        })
        .then(res => {
          const self = this
          if (res) {
            res.addEventListener('beforeunload', () => {
              self.popup.close()
              self.popup = null
            })

            self.popup = res
          }
        })
    }
  },
  watch: {
    refreshInterval (val) {
      if (this.isStarted) {
        this.stopMon()
        this.startMon()
      }
    },
    chartTimeScale (val) {
      this.refreshInterval = this.chartTimeScale.resolution
    }
  }
}
</script>

<style scoped>
.solid-background {
  background-color: #1e1e1e
}
</style>
